import {Component, Input, OnInit} from '@angular/core';
import {ElementLogViewModalComponent} from '../../modals/element-log--view-modal/element-log-view-modal.component';
import {ModalService} from 'ngx-dynamic-modal';

@Component({
  selector: 'app-logs-table',
  templateUrl: './logs-table.component.html',
  styleUrls: ['./logs-table.component.scss']
})
export class LogsTableComponent implements OnInit {

    @Input() elements: Array<Object> = [];

    constructor(private modalService: ModalService) { }


    ngOnInit() {
    }

    openModal(data) {
        this.modalService.addDynamicComponent(ElementLogViewModalComponent, {data}, (res) => {

        })
    }

    getFromExtra(row: Object, field: string): string {
        if(row['extra'].hasOwnProperty(field)){
            return row['extra'][field];
        }
        return '';
    }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/tools/elements/components/logs-table/logs-table.component.ts